import graph from "@irati/utils/services/graph"
import {CompanyValue} from "../../types"

interface LoadCompanyValueQueryVariables {
  limit: number,
  tenantID: string
}

const getCompanyValues = (variables: LoadCompanyValueQueryVariables): Promise<CompanyValue[]> => {
  const query = `
    query CompanyValues($limit: Int, $tenantId: String!) {
      companyValues(limit: $limit, tenantId: $tenantId) {
        results {
          icon {
            href
            alt
          }
          name
          uuid
          tag
        }
      }
    }
  `

  return graph({query, variables}).then((data: any) => {
    return Promise.resolve(data.companyValues)
  })
}

export default getCompanyValues
